export default {
  methods: {
    updateExpansion(value, itemSelector, container = this.$el) {
      if (!container) return
      if (value) {
        this.$el.classList.add('expanded')
        // make all the items selectable
        container.querySelectorAll(itemSelector).forEach(el => {
          el.classList.add('select-list-item')
        })
      } /* if it is collapsed */ else {
        this.$el.classList.remove('expanded')
        container.querySelectorAll(itemSelector).forEach(el => {
          // make items non-selectable
          el.classList.remove('select-list-item')
          if (el.classList.contains('selected')) {
            // if any of the item inside collapsed list was selected, select the list (header)
            el.classList.remove('selected')
            this.$el.classList.add('selected')
          }
        })
      }
    }
  }
}
